export default [
    {
        path: "/lucky-draw/campaign/list",
        name: "lucky-draw-campaign-list",
        component: () =>
            import(
                "@/views/pages/lucky-draw/lucky-draw-campaign/CampaignList.vue"
            ),
        meta: {},
        breadcrumb: [
            {
                text: "Lucky Draw",
                to: "/lucky-draw/campaign/list",
            },
            {
                text: "Campaign List",
                active: true,
            },
        ],
    },
    {
        path: "/lucky-draw/campaign/create",
        name: "lucky-draw-campaign-create",
        component: () =>
            import(
                "@/views/pages/lucky-draw/lucky-draw-campaign/CampaignInfo.vue"
            ),
        meta: {},
        breadcrumb: [
            {
                text: "Lucky Draw",
                to: "/lucky-draw/campaign/list",
            },
            {
                text: "Create Campaign",
                active: true,
            },
        ],
    },
    {
        path: "/lucky-draw/campaign/info/:campaignId",
        name: "lucky-draw-campaign-info",
        component: () =>
            import(
                "@/views/pages/lucky-draw/lucky-draw-campaign/CampaignInfo.vue"
            ),
        meta: {},
        breadcrumb: [
            {
                text: "Lucky Draw",
                to: "/lucky-draw/campaign/list",
            },
            {
                text: "Edit Campaign",
                active: true,
            },
        ],
    },
    {
        path: "/lucky-draw/campaign/createWinner",
        name: "lucky-draw-campaign-createWinner",
        component: () =>
            import(
                "@/views/pages/lucky-draw/winner-anouncement-campaign/CampaignWinnerInfo.vue"
            ),
        meta: {},
        breadcrumb: [
            {
                text: "Winner Anouncement",
                to: "/winner-anouncement/campaign/list",
            },
            {
                text: "Create Campaign",
                active: true,
            },
        ],
    },
    {
        path: "/lucky-draw/campaign/infoWinner/:campaignId",
        name: "lucky-draw-campaign-infoWinner",
        component: () =>
            import(
                "@/views/pages/lucky-draw/winner-anouncement-campaign/CampaignWinnerInfo.vue"
            ),
        meta: {},
        breadcrumb: [
            {
                text: "Winner Anouncement",
                to: "/winner-anouncement/campaign/list",
            },
            {
                text: "Edit Campaign",
                active: true,
            },
        ],
    },
    {
        path: "/winner-anouncement/campaign/list",
        name: "winner-anouncement-campaign-list",
        component: () =>
            import(
                "@/views/pages/lucky-draw/winner-anouncement-campaign/CampaignWinnerList.vue"
            ),
        meta: {},
        breadcrumb: [
            {
                text: "Winner Anouncement",
                to: "/winner-anouncement/campaign/list",
            },
            {
                text: "Campaign List",
                active: true,
            },
        ],
    },
]